export const GlobalEvent = {
  EMAIL_DRAFT_UPDATED: 'EMAIL_DRAFT_UPDATED',
  EMAIL_SENT: 'EMAIL_SENT',
} as const;

export type GlobalEvent = (typeof GlobalEvent)[keyof typeof GlobalEvent];

export const globalEventDispatcher = (event: GlobalEvent) => {
  window.dispatchEvent(new Event(event));
};
